import React from 'react'
import { Formik, Field } from 'formik'

import { Button, Form, Col, Modal } from '_zari/core'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'
import Yup from '_zari/validation/_yup'

import { DownloadAxiosFile } from 'utils'

import * as TurnoService from 'services/turno.service'

const ValidationSchema = Yup.object().shape({
  efectivoFin: Yup.number().min(0).required()
})

const CerrarTurnoPage = ({ history }) => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const [mostrarModal, setMostrarModal] = React.useState(true)

  const formInitialValues = React.useMemo(
    () => ({
      efectivoFin: 0
    }),
    []
  )

  const handleClose = React.useCallback(() => {
    setMostrarModal(false)
    history.push('/')
  }, [history])

  const submitHandler = async data => {
    await TurnoService.self
      .cerrarTurno(data)
      .then(({ data: data2 }) => {
        __zariContext.snack('success', 'El turno se ha cerrado.')
        __adminContext.setEstadoTurno(false)
        __adminContext.setIdIslaActiva('')

        TurnoService.descargarTicketCierrexId(data2.hash)
          .then(({ data, headers }) => {
            DownloadAxiosFile.downloadAsBlob(data, headers)
            handleClose()
          })
          .catch(({ data: { error } }) => __zariContext.snack('error', error))
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <Modal show={mostrarModal}>
      <Modal.Header>
        <Modal.Title>CERRAR TURNO</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, setValues, touched, values }) => (
          <Form>
            <Modal.Body>
              <Form.Group>
                <Form.Label text='EFECTIVO FIN' htmlFor='input-efectivoFin' md={4} />
                <Col md={8}>
                  <Field name='efectivoFin'>
                    {({ field }) => (
                      <Form.InputNumber
                        {...field}
                        isInvalid={touched.efectivoFin && errors.efectivoFin}
                        disabled={isSubmitting}
                        id='input-efectivoFin'
                      />
                    )}
                  </Field>
                  {touched.efectivoFin && errors.efectivoFin ? (
                    <Form.Feedback type='invalid'>{errors.efectivoFin}</Form.Feedback>
                  ) : null}
                </Col>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit} disabled={isSubmitting}>
                Cerrar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(CerrarTurnoPage)
